/**
 * Bare-minimum profile gate: display name present.
 *
 * Deliberately only the name. A stricter check here (it once also required the vibe check)
 * means the route guards bounce someone back into onboarding between its own saves, which
 * reads as a broken stepper. Everything beyond the name is tracked by IntakeCompletedAt and
 * asked for by the resume notice, never enforced by a redirect.
 *
 * @param {Object|null} profile
 * @returns {boolean}
 */
export const isProfileComplete = (profile) => {
  if (!profile) return false;
  return !!profile.displayName;
};

/**
 * Has the person finished onboarding? Distinct from isProfileComplete — an account can have a
 * name (passing that) and still owe every other answer. Stamped by GO LIVE on `/onboard`'s
 * last step; the resume notice and the profile photo gate read it, no route guard does.
 *
 * @param {Object|null} profile - The user's profile object
 * @returns {boolean}
 */
export const isIntakeComplete = (profile) => {
  if (!profile) return false;
  return !!profile.intakeCompletedAt;
};
